/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */
import React from 'react';
import { timeAgo } from '@/lib/utils-cat';

export const NotificationItem = ({ n, t, onClick }) => (
  <button
    onClick={() => onClick(n)}
    className={`w-full text-left px-3 py-2 hover:bg-secondary/60 border-b border-border last:border-b-0 ${!n.read ? 'bg-primary/5' : ''}`}
    data-testid="notification-item"
  >
    <div className="text-sm flex items-start gap-2">
      {!n.read && <span className="mt-1.5 h-2 w-2 rounded-full bg-primary shrink-0" />}
      <div className="flex-1 min-w-0">
        <div className="line-clamp-2">{n.content}</div>
        <div className="text-[11px] text-muted-foreground mt-0.5">{timeAgo(n.created_at, t)}</div>
      </div>
    </div>
  </button>
);

export const UnreadBadge = ({ count }) => {
  if (count <= 0) return null;
  return (
    <span
      className="absolute top-1 right-1 min-w-[16px] h-4 px-1 rounded-full bg-destructive text-destructive-foreground text-[10px] font-semibold flex items-center justify-center"
      data-testid="notifications-badge"
    >
      {count > 9 ? '9+' : count}
    </span>
  );
};
